import React from "react";
// material ui core
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import CircularProgress from "@material-ui/core/CircularProgress";

// Custom components
import { Dashboard as DashboardLayout } from "../../../../layouts/";
// Styles
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import subscriptionCommon from "./common";
import CountersInfo from "../SubscriptionInfo/countersInfo";

class LoadingPage extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <DashboardLayout title="Profile">
        <Grid container spacing={5}>
          <Grid item lg={12} xs={12} md={12}>
            <Paper className={classes.root} elevation={1} style={{ position: "relative" }}>
              <CircularProgress style={{ marginLeft: "50%" }} />
            </Paper>
          </Grid>
        </Grid>
      </DashboardLayout>
    );
  }
}

LoadingPage.propTypes = {};

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({}, dispatch),
    dispatch
  };
}

LoadingPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadingPage);

export default withStyles(subscriptionCommon.styles)(LoadingPage);
